module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<div class=\"container-slim section-margin\"> <h3>Thank you</h3> <p>Your account is now enrolled in the ")
    ; __append(escapeFn( locals.planQuantity ))
    ; __append(" ")
    ; __append(escapeFn( locals.planName ))
    ; __append(" Lookups/")
    ; __append(escapeFn( locals.planInterval ))
    ; __append(" plan. Please check your account for plan and billing details. ")
    ;  if(!locals.loggedIn) { 
    ; __append(" To get started, please check your email for a verification link in order to log in to your account. You can then enter your payment information on the billing page and retrieve your api-key. There are also lots of helpful <a href=\"/docs/api\">docs</a> to get you started.</p> ")
    ;  } else { 
    ; __append(" <p></p> <a href=\"/account/billing\" class=\"btn btn-blue\" type=\"button\">Go to account page</a> ")
    ;  } 
    ; __append(" </div> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./templates/checkout-success-page.ejs
// module id = 880
// module chunks = 1